import { eventCodeTypesFromOid } from 'dmpconnectjsapp-base/utils/eventCodes'
import moment                    from 'moment/moment'
import { existInObject }         from '../helpers/searchUtils'

export const tableSortAuthors = (rowA, rowB, columnId) => {
  const authorA = rowA.values[columnId]
  const authorB = rowB.values[columnId]
  const nameA   = authorA[0].s_hpGiven + authorA[0].s_hpName
  const nameB   = authorB[0].s_hpGiven + authorB[0].s_hpName
  if (nameA === nameB) {
    return 0
  }
  return nameA > nameB ? 1 : -1
}

export const tableSortAuthor = (rowA, rowB, columnId) => {
  const authorA = rowA.values[columnId]
  const authorB = rowB.values[columnId]
  const nameA   = authorA.s_hpGiven + authorA.s_hpName
  const nameB   = authorB.s_hpGiven + authorB.s_hpName
  if (nameA === nameB) {
    return 0
  }
  return nameA > nameB ? 1 : -1
}

export const tableSortDates = (rowA, rowB, columnId) => {
  const dateA = moment(rowA.values[columnId], ['YYYYMMDDHHmmss', 'YYYYMMDD'])
  const dateB = moment(rowB.values[columnId], ['YYYYMMDDHHmmss', 'YYYYMMDD'])
  
  if (dateA.isSame(dateB)) {
    return 0
  }
  return dateA.isAfter(dateB) ? 1 : -1
}

export const filterDates = (rows = [], ids = [], filterValue) => rows.filter(row => ids.some((id) => {
  const rowValue             = row.values[id]
  const { datemin, datemax } = filterValue
  const momentValue          = moment.utc(rowValue, 'YYYYMMDDHHmmss')
  
  return momentValue.isBetween(datemin, datemax, null, '[]')
}))

export const filterSpecialty = (rows = [], ids = [], filterValue) => {
  if (!filterValue) {
    return rows
  }
  return rows.filter(row => ids.some((id) => {
    const rowValue = row.values[id]
    return rowValue.some(author => author.s_hpSpeciality === filterValue)
  }))
}

export const filterAuthors = (rows = [], ids = [], filterValue) => rows.filter(row => ids.some((id) => {
  const rowValue = row.values[id]
  return rowValue.findIndex((author) => {
    const authorName = author.s_hpGiven.concat(' ').concat(author.s_hpName).toLowerCase()
    return authorName.indexOf(filterValue.toLowerCase()) !== -1
  }) !== -1
}))
export const filterAuthor  = (rows = [], ids = [], filterValue) => rows.filter(row => ids.some((id) => {
  const rowValue   = row.values[id]
  const authorName = rowValue.s_hpGiven.concat(' ').concat(rowValue.s_hpName).toLowerCase()
  return authorName.indexOf(filterValue.toLowerCase()) !== -1
}))

export const filterAll = (rows = [], ids = [], filterValue = []) => rows.filter(row => {
  // return true;
  return !filterValue || filterValue.trim().split(' ').every(part => existInObject(part, row.original))
})

export const filterEventCodes = (rows = [], ids = [], filterValue = []) => rows.filter(row => ids.some((id) => {
  const rowValue = row.values[id] // EventCodes
  
  if (!(filterValue && filterValue.length > 0)) {
    return true
  }
  if (!(rowValue && rowValue.length > 0)) {
    return false
  }
  
  return rowValue.some(
    docEventCode => filterValue.some(
      filterEventCode => (
        docEventCode.s_eventCodeCode === filterEventCode.s_code
        && filterEventCode.s_codeSystem === Object.keys(eventCodeTypesFromOid)[docEventCode.i_eventCodeClassification - 1]
      ),
    ))
}))

export const filterReferenceIds = (rows = [], ids = [], filterValue = []) => rows.filter(row => ids.some((id) => {
  const rowValue = row.values[id] || [] // ReferenceIds
  
  if (!(filterValue && filterValue.length > 0)) {
    return true
  }
  if (!(rowValue && rowValue.length > 0)) {
    return false
  }
  
  return rowValue.some(
    docRef => filterValue.some(
      filterRef => (
        (
          (docRef.s_identifier === filterRef.s_identifier && filterRef.i_approxIdentifier === 0)
          || (docRef.s_identifier.indexOf(filterRef.s_identifier) !== -1 && filterRef.i_approxIdentifier === 1)
        )
        && (!filterRef.s_oid || docRef.s_oid === filterRef.s_oid)
        && docRef.s_typecode === filterRef.s_typecode
      ),
    ))
}))
